import { Component, input } from '@angular/core';
import { NgDiagramPortComponent, NgDiagramNodeSelectedDirective } from 'ng-diagram';

@Component({
  selector: 'app-tree-node-template',
  standalone: true,
  imports: [NgDiagramPortComponent, NgDiagramNodeSelectedDirective],
  templateUrl: './tree-node-template.component.html',
  styleUrls: ['./tree-node-template.component.scss'],
})
export class TreeNodeTemplateComponent {
  node = input.required<any>();
}
